<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <div class="headTab d-flex align-items-center">
          <h1 class="page-name" *ngFor="let tab of tabs" [ngClass]="{'active': tab.tabName == activeTab.tabName }" (click)="setActiveTab(tab)">{{ tab.tabName }}</h1>
        </div>

        <!-- <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection">
            <span>$ {{ leads.totalPay }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </p>
          <div class="year-selection-m">
            <!-- Modal --
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Total : $ {{ leads.totalPay }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p">
                      <li *ngFor="let paymentPart of leads.dispositionTotal">
                        <label>{{ totalPaymentSearch(paymentPart.status ,despositionArray) }}</label>
                        <span>$ {{ paymentPart.totpay }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="filter-sub-m w-auto pl-5 border-left">
          <div class="filter-m p-0">
            <div class="filter">
              <div class="fields-m">
                <input type="text" name="search" [(ngModel)]="searchParams.info" (change)="rerender()" placeholder="Search by Customer Info">
                <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
              </div>
            </div>
            <div class="filter">
              <div class="fields-m date-filter">
                <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                  <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                  <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                  <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                  <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                  <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                  <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                  <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                  <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                  <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                  <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                  <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                  <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                  <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                  <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
                </svg>
              </div>
            </div>

            <div class="filter" *ngIf="activeTab.tabName != 'Checked Prices' && activeTab.tabName != 'All Customers'">
              <!-- <div class="fields-m">
                <input type="text" name="search" [(ngModel)]="searchParams.minLimit" (change)="rerender()" placeholder="Search by Minimum limit">
                <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
              </div> -->

              <div class="fields-m select-m">
                <ng-select
                  [items]="minLimit"
                  bindLabel="name"
                  bindValue="val"
                  placeholder="Select Minimum limit"
                  [(ngModel)]="searchParams.minLimit"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="true"
                  appendTo=".top-section"
                  (change)="rerender()"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="filter" *ngIf="activeTab.tabName != 'Checked Prices' && activeTab.tabName != 'All Customers'">
              <div class="fields-m select-m">
                <ng-select
                  [items]="minLimit"
                  bindLabel="name"
                  bindValue="val"
                  placeholder="Select Maximum limit"
                  [(ngModel)]="searchParams.maxLimit"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="true"
                  appendTo=".top-section"
                  (change)="rerender()"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="filter">
              <div class="fields-m select-m select-site-link">
                <ng-select
                  [items]="siteLinks"
                  bindLabel="site_link"
                  bindValue="site_link"
                  placeholder="Select Site Link"
                  [(ngModel)]="searchParams.site_link"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="true"
                  appendTo=".top-section"
                  (change)="rerender()"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.site_link }}
                  </ng-template>
                </ng-select>
                <!-- <input type="text" name="search" [(ngModel)]="searchParams.site_link" (change)="rerender()" placeholder="Search by Site Link"> -->
                <!-- <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i> -->
              </div>
            </div>

            <!-- <div class="clear-m mr-3" *ngIf="activeTab.tabName == 'All Customers'"> -->
            <div class="clear-m mr-3">
              <div class="clear" (click)="prepareExcelData()">
                <span>Export </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none">
                  <path d="M14.9793 4.21487C14.9587 4.21487 14.9587 4.19421 14.938 4.17355C14.9174 4.15289 14.9174 4.13223 14.8967 4.11157L11.343 0.123967C11.3223 0.103306 11.281 0.0826446 11.2603 0.0619835C11.2397 0.0619835 11.2397 0.0413223 11.219 0.0413223C11.1777 0.0206612 11.1157 0 11.0537 0H2.33471C1.05372 0 0 1.05372 0 2.33471V16.6529C0 17.9339 1.05372 18.9876 2.33471 18.9876H12.6653C13.9463 18.9876 15 17.9339 15 16.6529V4.3595C15 4.31818 14.9793 4.2562 14.9793 4.21487ZM11.4463 1.40496L13.7397 3.9876H11.4463V1.40496ZM14.2149 16.6322C14.2149 17.5 13.5331 18.2025 12.6653 18.2025H2.33471C1.46694 18.2025 0.785124 17.5 0.785124 16.6529V2.31405C0.785124 1.44628 1.4876 0.764463 2.33471 0.764463H10.6612V4.3595C10.6612 4.56611 10.8264 4.75206 11.0537 4.75206H14.2149V16.6322Z" fill="black"/>
                  <path d="M2.78953 4.75216H6.23995C6.44656 4.75216 6.63251 4.58688 6.63251 4.3596C6.63251 4.13233 6.46722 3.96704 6.23995 3.96704H2.78953C2.58292 3.96704 2.39697 4.13233 2.39697 4.3596C2.39697 4.58688 2.58292 4.75216 2.78953 4.75216Z" fill="black"/>
                  <path d="M6.23995 14.2356H2.78953C2.58292 14.2356 2.39697 14.4009 2.39697 14.6282C2.39697 14.8348 2.56226 15.0207 2.78953 15.0207H6.23995C6.44656 15.0207 6.63251 14.8554 6.63251 14.6282C6.63251 14.4215 6.44656 14.2356 6.23995 14.2356Z" fill="black"/>
                  <path d="M2.39697 6.96287C2.39697 7.16949 2.56226 7.35544 2.78953 7.35544H12.0044C12.211 7.35544 12.397 7.19015 12.397 6.96287C12.397 6.75626 12.2317 6.57031 12.0044 6.57031H2.78953C2.58292 6.57031 2.39697 6.7356 2.39697 6.96287Z" fill="black"/>
                  <path d="M12.0044 8.51245H2.78953C2.58292 8.51245 2.39697 8.67774 2.39697 8.90501C2.39697 9.11162 2.56226 9.29757 2.78953 9.29757H12.0044C12.211 9.29757 12.397 9.13228 12.397 8.90501C12.397 8.67774 12.2317 8.51245 12.0044 8.51245Z" fill="black"/>
                  <path d="M12.0044 10.4338H2.78953C2.58292 10.4338 2.39697 10.5991 2.39697 10.8264C2.39697 11.033 2.56226 11.219 2.78953 11.219H12.0044C12.211 11.219 12.397 11.0537 12.397 10.8264C12.397 10.5991 12.2317 10.4338 12.0044 10.4338Z" fill="black"/>
                  <path d="M12.0044 12.3555H2.78953C2.58292 12.3555 2.39697 12.5208 2.39697 12.748C2.39697 12.9546 2.56226 13.1406 2.78953 13.1406H12.0044C12.211 13.1406 12.397 12.9753 12.397 12.748C12.397 12.5414 12.2317 12.3555 12.0044 12.3555Z" fill="black"/>
                </svg>
              </div>
            </div>
            <!-- <div class="filter">
              <div class="fields-m select-m">
                <ng-select
                [items]="agents"
                bindLabel="name"
                bindValue="id"
                placeholder="Writers’ type"
                [(ngModel)]="searchParams.agent_id"
                [ngModelOptions]="{standalone: true}"
                [searchable]="true"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div> -->
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th style="width: 20%">Recent most {{ activeTab.thName }} timestamp</th>
              <th style="width: 20%">Customer Info</th>
              <th style="width: 20%">Total {{ activeTab.thName }} with us</th>
              <th style="width: 20%">Total $ {{ activeTab.thName }}</th>
              <th style="width: 20%">Customer Since</th>
              <th style="width: 20%">Action</th>
              <th style="width: 20%">Site Link</th>
              <th style="width: 20%">Status</th>
            </tr>
          </thead>

          <tbody *ngIf="leads.data && leads.data.length > 0 && activeTab.tabName != 'Checked Prices' && activeTab.tabName != 'All Customers'">
            <tr *ngFor="let lead of leads.data; let indx = index">
              <td>
                <span *ngIf="lead.order_details.recent_order_date">{{ lead.order_details.recent_order_date | customDatePipe: 'shortTime' }}</span>
                <span *ngIf="!lead.order_details.recent_order_date">-</span>
              </td>

              <td>
                <p>{{ lead.first_name }}</p>
                <p>{{ lead.phone }}</p>
                <p>{{ lead.email }}</p>
              </td>

              <td>
                <p class="page-td" *ngIf="lead.order_details.orders_count">{{ lead.order_details.orders_count }}</p>
                <p class="page-td" *ngIf="!lead.order_details.orders_count">0</p>
              </td>

              <td>
                <p class="page-td" *ngIf="lead.order_details.total_amount">{{ lead.order_details.total_amount }}</p>
                <p class="page-td" *ngIf="!lead.order_details.total_amount">0</p>
              </td>

              <td>
                <span *ngIf="lead.order_details.first_order_date">{{ lead.order_details.first_order_date | customDatePipe: 'shortTime' }}</span>
                <span *ngIf="!lead.order_details.first_order_date">-</span>
              </td>

              <td>
                <a href="javascript:;" target="_blank" *ngIf="lead.order_details.orders.length > 0" routerLink="/customer-orders/{{ lead.id | base64 }}">View All Orders</a>
              </td>
            </tr>
          </tbody>

          <!-- For Leads -->
          <tbody *ngIf="leads.data && leads.data.length > 0 && activeTab.tabName == 'Checked Prices'">
            <tr *ngFor="let lead of leads.data; let indx = index">
              <td>
                <span *ngIf="lead.date">{{ lead.date | customDatePipe: 'shortTime' }}</span>
                <span *ngIf="!lead.date">-</span>
              </td>
              <td>
                <p>
                  <ng-container *ngIf="lead.first_name">{{ lead.first_name }}</ng-container>
                  <ng-container *ngIf="!lead.first_name">-</ng-container>
                </p>
                <p>
                  <ng-container *ngIf="lead.phone">{{ lead.phone }}</ng-container>
                  <ng-container *ngIf="!lead.phone">-</ng-container>
                </p>
                <p>
                  <ng-container *ngIf="lead.email">{{ lead.email }}</ng-container>
                  <ng-container *ngIf="!lead.email">-</ng-container>
                </p>
              </td>
              <td>
                <span *ngIf="lead.leads_count">{{lead.leads_count}}</span>
              </td>
              <td>
                <span *ngIf="lead.total_paid">{{lead.total_paid}}</span>
                <span *ngIf="!lead.total_paid">0</span>
              </td>
              <td>
                <span *ngIf="lead.date">{{ lead.date | customDatePipe: 'shortTime' }}</span>
                <span *ngIf="!lead.date">-</span>
              </td>
            </tr>
          </tbody>

          <!-- For all customers tab -->
          <tbody *ngIf="leads.data && leads.data.length > 0 && activeTab.tabName == 'All Customers'">
            <tr *ngFor="let lead of leads.data; let indx = index">
              <td>
                <span *ngIf="lead.date">{{ lead.date | customDatePipe: 'shortTime' }}</span>
                <span *ngIf="!lead.date">-</span>
              </td>
              <td>
                <p>
                  <ng-container *ngIf="lead.name">{{ lead.name }}</ng-container>
                  <ng-container *ngIf="!lead.name">-</ng-container>
                </p>
                <p>
                  <ng-container *ngIf="lead.phone">{{ lead.phone }}</ng-container>
                  <ng-container *ngIf="!lead.phone">-</ng-container>
                </p>
                <p>
                  <ng-container *ngIf="lead.email">{{ lead.email }}</ng-container>
                  <ng-container *ngIf="!lead.email">-</ng-container>
                </p>
                <p>
                  <ng-container *ngIf="lead.user">{{ lead.user.password }}</ng-container>
                  <ng-container *ngIf="!lead.user">-</ng-container>
                </p>
                <p>
                  <ng-container *ngIf="lead.user">{{ lead.user.otp }}</ng-container>
                  <ng-container *ngIf="!lead.user">-</ng-container>
                </p>
              </td>
              <td>
                <span *ngIf="lead.site_link">{{lead.site_link}}</span>
              </td>
              <td>
                <span *ngIf="lead.paid">Paid</span>
                <span *ngIf="!lead.paid">Unpaid</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- view more orders modal -->
<div class="mainModal">
  <div class="modal fade" id="moreOrders" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 428px;" role="document">
      <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
      <div class="modal-content">
        <div class="modal-body d-block p-4">
            <p>Total Orders: {{ custOrders.length }}</p>
            <div class="roundedShape moreOrders text-center mb-4">
                <a href="javascript:;" *ngFor="let order of custOrders">
                    <span [ngClass]="{'invalidBox': activeTab.tabName != 'Paid', 'validBox': activeTab.tabName == 'Paid'}">
                      <a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ order.id | base64 }}">{{ order.order_id }}</a>
                      <!-- {{ order.order_id }} -->
                    </span>
                </a>
            </div>
          <div class="formBtns w-100">
              <button class="resetBtn" data-dismiss="modal" aria-label="Close">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view more orders modal -->
